import type { RobisFormConfig } from '#types/config/components/form/robis'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    requiredField: 'body-5 c-grey-20'
  },
  checkboxSize: 'sm'
} satisfies RecursivePartial<RobisFormConfig>
